import getShowableElements from './hint-message/get-showable-elements';
import hintsInTheDom from './hint-message/hints-in-the-dom';
import setHintPositionFromAttribute from './hint-message/set-hint-position-from-attribute';
import calculateHintPosition from './hint-message/calculate-element-position';
import showHint from './hint-message/show-hint';
import closeHint from './hint-message/close-hint';
import closeAllHints from './hint-message/close-all-hints';


export default function (app) {
	app.directive('hintMessage', function ($document, HintService, $timeout, $http, $rootScope, $filter) {
		var link = function (scope) {
			angular.element(document).ready(function () {
				/**
				 * Aktuális hint és befoglaló elem, amire az overlay kerül
				 * hints: a service-ból érkező hint tömb
				 * body: befoglaló elem a documentumon belül
				 * config: a megjelenítéshez kapcsolódó konfiguráció
				 */
				var tabletBreakPoint = 768;

				var hints = HintService.getHints();
				var body = $document.find('.app-ebiz').eq(0);
				var config = {
					tooltipWidth: 300,
					paddingWidth: 12,
					pagePadding: $document.innerWidth() < tabletBreakPoint ? 0 : 80
				};

				scope.getHintsOnPage = [];
				scope.hintsExpressions = [];

				/**
				 * Megvárjuk, amíg az adott oldalon minden AJAX és kiértékelési művelet befejeződött
				 * Angular specifikus
				 */

				var waitForRenderAndAjax = function () {
					if ($http.pendingRequests.length > 0) {
						$timeout(waitForRenderAndAjax, 20);
					} else {
						scope.getHintsOnPage = angular.element(document.querySelectorAll('[hint-message]'));
						scope.hintsExpressions = hintsInTheDom();
					}
				};

				scope.$on('$locationChangeSuccess', function () {
					$timeout(waitForRenderAndAjax, 20);
				});

				$rootScope.$on('hintMessage', function () {
					$timeout(waitForRenderAndAjax, 20);
				});

				$timeout(waitForRenderAndAjax, 20);


				/**
				 * Watch esemény a logikai változásokhoz
				 */

				scope.$watchCollection('hintsExpressions', function (newVal, oldVal) {
					if (newVal && oldVal) {
						hints = HintService.getHints();
						scope.showableElements = getShowableElements(hints, scope.getHintsOnPage);

					}
				});

				/**
				 * Mutatható elemek figyelése, sorrendben történő megjelenítése
				 */
				scope.$watch(function () {
					return scope.showableElements.length;
				}, function (newVal, oldVal) {
					if (oldVal != newVal && newVal > 0) {

						showHint(angular.element(scope.showableElements[0]), body, HintService, $filter);
						setHintPositionFromAttribute(angular.element(scope.showableElements[0]), config, body, angular.element(scope.showableElements[0]).attr('hint-alignment'));

						if (window.matchMedia('(max-width: 768px)').matches) {
							calculateHintPosition(angular.element(scope.showableElements[0]), config, body, $document);
						}


						body.find('.understand').on('click', function (e) {
							e.preventDefault();
							closeHint(angular.element(scope.showableElements[0]), body, HintService, scope);
						});

						body.find('.hints-close').on('click', function (e) {
							e.preventDefault();
							closeAllHints(angular.element(scope.showableElements[0]), body, HintService, scope);

						});

						angular.element(window).on('resize', function () {
							calculateHintPosition(angular.element(scope.showableElements[0]), config, body, $document);
						});

					}


				});


			});
		};
		return {
			restrict: 'E',
			scope: {},
			link: link
		};
	});
};
